/**
 * Title case.
 * https://stackoverflow.com/questions/196972/convert-string-to-title-case-with-javascript
 */
export const toTitleCase = (value) => {
    return value.replace(
        /\w\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
};